const cookiesTypes = {
  HAS_COOKIE_CONSENT: "HAS_COOKIE_CONSENT",
  CLOSE_COOKIE_CONSENT: "CLOSE_COOKIE_CONSENT",
  OPEN_COOKIE_CONSENT: "OPEN_COOKIE_CONSENT",
  REMOVE_TRANSITION: "REMOVE_TRANSITION",
};

export default cookiesTypes;
